/**
 * @name WithUrqlClient
 * @description HOC to expose the Urql client instance to the props
 * @module lib/with-urql-client
 * @author German Alfonso <galfonso@lululemon.com>
 *
 * @example
 * import WithUrqlClient from 'lib/with-urql-client';
 */

// THIRD-PARTY
import * as React from "react";
import PropTypes from "prop-types";
import { Consumer } from "urql";

export {
  Provider as UrqlProvider,
  createClient as urqlCreateClient,
} from "urql";

// eslint-disable-next-line react/display-name
const WithUrqlClient = (Component) => (props) =>
  (
    <Consumer>
      {(graphqlClient) => (
        <Component {...props} graphqlClient={graphqlClient} />
      )}
    </Consumer>
  );

WithUrqlClient.propTypes = {
  Component: PropTypes.Component,
};

export default WithUrqlClient;
